import { render, staticRenderFns } from "./VContextList.vue?vue&type=template&id=668f5308&"
import script from "./VContextList.vue?vue&type=script&lang=ts&"
export * from "./VContextList.vue?vue&type=script&lang=ts&"
import style0 from "./VContextList.vue?vue&type=style&index=0&id=668f5308&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports